import * as Yup from 'yup';
import { fields } from '@synergy/utils';

import { SupplierDetailOverviewFormValues } from './models/supplier-detail-overview-form-values';

const fieldNames = fields<SupplierDetailOverviewFormValues>();

export const supplierDetailOverviewValidationSchema = Yup.object().shape({
    [fieldNames.addresses]: Yup.array()
        .of(
            Yup.object().shape({
                street: Yup.string().required('app.error.required'),
                zip: Yup.string().required('app.error.required'),
                city: Yup.string().required('app.error.required'),
                country: Yup.object().required('app.error.required'),
                isDefaultAddress: Yup.boolean().required('app.error.required'),
            })
        )
        .min(1, 'app.error.required'),
    [fieldNames.mainEmail]: Yup.string().email('app.error.email').required('app.error.required'),
    emails: Yup.array().of(
        Yup.object().shape({
            type: Yup.mixed().required(),
            email: Yup.string().email('app.error.email').required('app.error.required'),
        })
    ),
    [fieldNames.phones]: Yup.array().of(
        Yup.object().shape({
            type: Yup.mixed().required(),
            number: Yup.string().required('app.error.required'),
        })
    ),
    [fieldNames.name]: Yup.string().required('app.error.required'),
    // The GLN is optional, and a record without one reaches the form as an empty
    // string rather than as undefined — so both have to pass.
    [fieldNames.glnNumber]: Yup.string().test('glnNumber', 'app.error.glnLength', val => !val || val.length === 13),
    [fieldNames.ftpPassword]: Yup.string().test(
        // can be empty or should have a minimum of 8 chars
        'zeroOrMinEight',
        'app.error.passwordLength',
        (password?: string | null) => !password || password.length >= 8
    ),
    [fieldNames.newFtpPassword]: Yup.string().test(
        // can be empty or should have a minimum of 8 chars
        'zeroOrMinEight',
        'app.error.passwordLength',
        (password?: string | null) => !password || password.length >= 8
    ),
});
